import { clsx } from 'clsx';
import React from 'react';
import styles from '../product-timeline.module.scss';
import { TimelineStep, TimelineStepStatus } from '../interfaces/timeline';
import { Icon } from '../fake';

const OutlineView: React.FC<{
  step: TimelineStep;
}> = ({ step }) => {
  const { status, nextStepStatus } = step;
  const lastStep = nextStepStatus === 'none';
  const lastStepStyle = lastStep ? styles.ordersSales__mainRight__steps__step__last : '';

  const lineColors: Record<TimelineStepStatus, string> = {
    ongoing: styles.ordersSales__mainRight__steps__step__ongoingLine,
    cancelled: styles.ordersSales__mainRight__steps__step__cancelledLine,
    done: styles.ordersSales__mainRight__steps__step__doneLine,
    pending: styles.ordersSales__mainRight__steps__step__pendingLine,
    upcoming: styles.ordersSales__mainRight__steps__step__upcomingLine,
    none: '',
  };

  const lineStyle = lineColors[nextStepStatus];

  switch (status) {
    case 'ongoing':
      return <div className={clsx(styles.ordersSales__mainRight__steps__step__ongoing, lastStepStyle, lineStyle)} />;
    case 'done':
      if (lastStep === true) {
        return (
          <div className={clsx(styles.ordersSales__mainRight__steps__step__doneWithIcon, lastStepStyle, lineStyle)}>
            <Icon
              className={styles.ordersSales__mainRight__steps__step__doneWithIcon__icon}
              name="checkmark"
            />
          </div>
        );
      } else {
        return <div className={clsx(styles.ordersSales__mainRight__steps__step__done, lastStepStyle, lineStyle)} />;
      }
    case 'cancelled':
      return (
        <div className={clsx(styles.ordersSales__mainRight__steps__step__cancelled, lastStepStyle, lineStyle)}>
          <Icon
            className={styles.ordersSales__mainRight__steps__step__cancelled__icon}
            name="cross-x-thick"
          />
        </div>
      );
    case 'upcoming':
      return <div className={clsx(styles.ordersSales__mainRight__steps__step__upcoming, lastStepStyle, lineStyle)} />;
    case 'pending':
      return <div className={clsx(styles.ordersSales__mainRight__steps__step__pending, lastStepStyle, lineStyle)} />;
    case 'none':
      return <></>;
  }
};

export default OutlineView;
